import { Link } from 'react-router-dom';
import { highlights } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

const statusStyle: Record<string, string> = {
  核查中: 'bg-accent-500 text-foreground-950',
  已公开: 'bg-secondary-400 text-secondary-950',
  技术复核: 'bg-accent-500 text-foreground-950',
  征集线索: 'bg-primary-500 text-background-50',
};

export default function HighlightsSection() {
  return (
    <section className="bg-secondary-950 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <SectionHeading
              kicker="Tracking Desk"
              title="近期追踪议题"
              description="以下议题已进入我们的核查队列。如果你掌握相关信息，可以通过官方渠道补充材料，我们将持续公开进展状态。"
              tone="light"
            />
            <p className="font-mono text-xs text-background-400 shrink-0">
              更新于 2026.08.24 · 每两周同步一次
            </p>
          </div>

          <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {highlights.map((item) => (
              <article
                key={item.title}
                className="group flex flex-col bg-secondary-900/70 border border-secondary-800 rounded-lg overflow-hidden hover:border-accent-600 transition-colors"
              >
                <div className="w-full aspect-[4/3] overflow-hidden bg-secondary-900">
                  <img
                    src={item.image}
                    alt={`${item.tag}相关议题配图：${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                  />
                </div>
                <div className="flex flex-col flex-1 p-5 md:p-6">
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-accent-400">
                      {item.tag}
                    </span>
                    <span
                      className={`font-mono text-[10px] px-2 py-0.5 rounded-full ${
                        statusStyle[item.status] ?? 'bg-secondary-700 text-background-50'
                      }`}
                    >
                      {item.status}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-bold leading-snug text-background-50">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-xs md:text-sm leading-relaxed text-background-300 flex-1">
                    {item.excerpt}
                  </p>
                  <p className="mt-5 font-mono text-[11px] text-background-500">{item.date}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between border-t border-secondary-800 pt-8">
            <p className="text-sm text-background-200">
              你手上的材料，也许正是某个议题缺失的那一环。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-400 text-foreground-950 text-sm font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              为议题补充线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}